export const widthBreakpoints = {
  xl: 1439,
  xm: 1360,
  x: 1320,
  l: 1279,
  lg: 1212,
  ls: 1023,
  /**
   * The sidebar/top-bar switch. Same width as `ls`, but a named alias so the hamburger mode is
   * one deliberate decision: below it every page shows the 65px top bar (logo/account/hamburger)
   * instead of the desktop rail — covering portrait tablets and landscape phones (744–1023px)
   * that used to get the squeezed desktop rail with no hamburger.
   */
  menu: 1023,
  sl: 850,
  sm: 743,
  s: 479,
  xs: 320,
};

export const heightBreakpoints = {
  l: 900,
  lg: 860,
  ls: 835,
  sm: 800,
  s: 770,
  xs: 700,
};
